import { workspaces } from '@modules/shared/api/v2/hooks';

import type { Workspace } from '@modules/shared/api/v2/api';

type UseGetWorkspaceParams = {
  organizationId: string | null | undefined;
  workspaceId: string | null | undefined;
};

export const useGetWorkspace = ({
  organizationId,
  workspaceId,
}: UseGetWorkspaceParams) => {
  const { data, isLoading, error, mutate } = workspaces.queries.useWorkspaceById(
    organizationId ?? '',
    workspaceId ?? '',
    {
      key: organizationId && workspaceId ? undefined : null,
      revalidateOnFocus: false,
    },
  );

  return {
    data: data as Workspace | undefined,
    isLoading,
    error,
    mutate,
  };
};
